// Exact copy of C and TH from web/Clock_Web.html lines 91-110.
// NEVER hardcode these values elsewhere — import from here.

export const C = {
  primary: '#2485F4',
  success: '#28C76F',
  danger:  '#EA5455',
  teal:    '#53DBD4',
  blue:    '#2485F4', // alias for primary
  indigo:  '#5C6BC0',
} as const;

export const TH = {
  light: {
    bg:         '#FFFFFF',
    navBg:      '#FFFFFF',
    navBorder:  '#EBE9F1',
    text:       '#5E5873',
    textBody:   '#6E6B7B',
    textMuted:  '#B9B9C3',
    clockText:  '#121212',
    border:     '#EBE9F1',
    surfaceBg:  '#FFFFFF',
    rowBg:      '#F8F8F8',
    shadow:     '0 4px 24px rgba(0,0,0,.08)',
    camBg:      '#161D31',
    stepDone:   'rgba(36,133,244,.08)',
    stepBorder: 'rgba(36,133,244,.25)',
    modalBg:    'rgba(0,0,0,.45)',
  },
  dark: {
    bg:         '#161D31',
    navBg:      '#1e2a45',
    navBorder:  '#2d3a54',
    text:       '#D0D2D6',
    textBody:   '#B4B7BD',
    textMuted:  '#676D7D',
    clockText:  '#FFFFFF',
    border:     '#3B4253',
    surfaceBg:  '#283046',
    rowBg:      '#1e2a45',
    shadow:     '0 4px 24px rgba(0,0,0,.3)',
    camBg:      '#0d0d1a',
    stepDone:   'rgba(36,133,244,.15)',
    stepBorder: 'rgba(36,133,244,.35)',
    modalBg:    'rgba(0,0,0,.65)',
  },
} as const;

export type ThemeName   = keyof typeof TH;
export type ThemeTokens = typeof TH.light; // same shape for both variants
export type BrandColors = typeof C;
